const styles = () => ({
    containerMainData: {
        marginTop: '30px',
    },
    loading: {
        marginTop: '25px',
    },
});

export default styles;
